import Badge from '@repo/ui/badge'
import { useFormContext } from 'react-hook-form'

import { AssignJourneyToCenterInput } from '../../../../lib/types/models/center/center-input'
import { CenterToJourneyProperties } from '../../../../lib/types/models/center-to-journey/properties.center-to-journey'

const TotalNumberOfChildren = () => {
  const form = useFormContext<AssignJourneyToCenterInput>()
  const centerToJourney = form.watch('centerToJourneys')
  return (
    <Badge
      text={`Nombre total max de jeunes : ${CenterToJourneyProperties.getTotalNumberOfChildren(centerToJourney)}`}
      variant="warning"
    />
  )
}

export default TotalNumberOfChildren
